import {
	SERVER_CONFIG_BY_RESTAURANT_FAILURE,
	SERVER_CONFIG_BY_RESTAURANT_REQUEST,
	SERVER_CONFIG_BY_RESTAURANT_SUCCESS,
	SERVER_CONFIG_SUCCESS,
} from 'new-constants/api.constants';
import {ServerConfigState} from './server-config.reducer.types';

const initialState: ServerConfigState = {
	cache: {},
};

export const serverConfigReducer = (previousState = initialState, action): ServerConfigState => {
	switch (action && action.type) {
		case SERVER_CONFIG_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.appId]: action.payload,
				},
			};
			break;

		case SERVER_CONFIG_BY_RESTAURANT_REQUEST:
			return {
				...previousState,
			};
			break;

		case SERVER_CONFIG_BY_RESTAURANT_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.appId]: {
						...action.payload,
						restaurantId: action.payload.restaurantId,
					},
				},
			};
			break;
		case SERVER_CONFIG_BY_RESTAURANT_FAILURE:
			return {
				...previousState,
				isDataError: action.isDataError,
			};
			break;
		default:
			return previousState;
	}
};
